<div class="ue-wrap">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="fw-bold mb-0">Gastos unificados</h5>
    <button *ngIf="canAddExpenses && !showForm"
            type="button"
            class="btn btn-primary btn-sm d-flex align-items-center gap-2"
            (click)="openAddForm()">
      <i class="fas fa-plus"></i> Agregar gasto unificado
    </button>
  </div>

  <!-- Formulario de agregar gasto -->
  <div *ngIf="showForm" class="ue-add-form mb-3">
    <form [formGroup]="addForm">
      <div class="row g-2 align-items-end">
        <div class="col-12 col-sm-6 col-lg-3">
          <label class="form-label expense-label">Tipo de gasto</label>
          <select class="form-select" formControlName="expense_type"
                  [class.is-invalid]="addForm.get('expense_type')?.invalid && addForm.get('expense_type')?.touched">
            <option value="">Seleccionar</option>
            <option *ngFor="let t of expenseTypes" [value]="t.value">{{ t.label }}</option>
          </select>
          <div class="invalid-feedback">Requerido</div>
        </div>
        <div class="col-12 col-sm-6 col-lg-2">
          <label class="form-label expense-label">Monto</label>
          <input type="number" class="form-control" formControlName="amount"
                 placeholder="0.00" step="0.01" min="0.01"
                 [class.is-invalid]="addForm.get('amount')?.invalid && addForm.get('amount')?.touched">
          <div class="invalid-feedback">Monto requerido y mayor a 0</div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <label class="form-label expense-label">Método de pago</label>
          <select class="form-select" formControlName="payment_method_id"
                  [class.is-invalid]="addForm.get('payment_method_id')?.invalid && addForm.get('payment_method_id')?.touched">
            <option value="">Seleccionar</option>
            <option *ngFor="let m of paymentMethods" [value]="m.id">{{ m.name }}</option>
          </select>
          <div class="invalid-feedback">Requerido</div>
        </div>
        <div class="col-12 col-sm-6 col-lg-2">
          <label class="form-label expense-label">Descripción (opcional)</label>
          <input type="text" class="form-control" formControlName="description" placeholder="Descripción">
        </div>
        <div class="col-12 col-lg-2 d-flex gap-2">
          <button type="button" class="btn btn-primary flex-fill" (click)="saveExpense()" [disabled]="isSaving">
            <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
            Guardar
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="cancelAdd()">Cancelar</button>
        </div>
      </div>
    </form>
  </div>

  <!-- Estado de carga -->
  <div *ngIf="isLoading" class="text-center py-4">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <!-- Sin registros -->
  <div *ngIf="!isLoading && expenseRows.length === 0" class="text-center text-muted py-4">
    No hay gastos unificados registrados.
  </div>

  <!-- Tabla de gastos unificados -->
  <div *ngIf="!isLoading && expenseRows.length > 0" class="ue-table-outer">
    <table class="ue-table">
      <colgroup>
        <col style="width:14%">
        <col style="width:20%">
        <col style="width:15%">
        <col style="width:28%">
        <col style="width:23%">
      </colgroup>
      <thead>
        <tr>
          <th class="text-center">Hora</th>
          <th>Tipo de gasto</th>
          <th class="text-end">Monto</th>
          <th>Detalle</th>
          <th>Aplicado a</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of expenseRows">
          <td class="td-time text-center">{{ row.created_at }}</td>
          <td>{{ expenseTypeLabel(row.expense_type) }}</td>
          <td class="td-amount text-end">{{ formatAmount(row.amount) }}</td>
          <td class="td-detail">{{ row.detail }}</td>
          <td>{{ row.aplicado_a }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Aviso estado no permitido -->
  <div *ngIf="!canAddExpenses" class="alert alert-warning mt-3 py-2 small">
    Solo se pueden agregar gastos unificados cuando el servicio está en estado <strong>Pendiente</strong>, <strong>Ruta a carga</strong> o <strong>Proceso de carga</strong>.
  </div>
</div>
